/**
 * @description Storage type enum
 */
export enum storageTypes {
  local = 'local',
  session = 'session',
  cookies = 'cookies'
};
